<template>
    <router-view />
</template>
<script>
/* @71168 */
export default {
    beforeRouteUpdate(to, from, next) {
        if (to.name == 'agro-planosafra') {
            next({ name: 'agro-planosafra-list' });
        } else {
            next();
        }
    },
    created() {
        if (this.$route.name == 'agro-planosafra') {
            this.$router.push({ name: 'agro-planosafra-list' });
        }
    },
};
</script>
